import React from "react";
import { HeldBet } from "@/features/betslip/components/overlays/HeldBet";

export const Delayed = () => (
  <HeldBet
    message="Your live bet is being confirmed"
    buttonLabel="Confirming"
    testId="delayed"
  />
);
